import {
  Button,
  Col,
  Input,
  Layout,
  message,
  Row,
  Switch,
  Typography,
} from 'antd';
import React from 'react';
import { FaFacebookF, FaGoogle, FaLinkedin } from 'react-icons/fa';
import {
  IoArrowUndo,
  IoEye,
  IoEyeOff,
  IoLockOpen,
  IoPerson,
} from 'react-icons/io5';
import ReactInputMask from 'react-input-mask';
import { Link, Navigate } from 'react-router-dom';
import { POST_API, POST_CATCH, setToken, setType } from '../../services/api';

class AuthLogin extends React.Component {
  state = {
    _navigate: false,
    load: false,
    side: 0,
    doc: false,
    view: false,
    form: {
      login: '',
      pass: '',
    },
  };

  onChangeValue = (field, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [field]: value,
      },
    });
  };

  onChangeSide = (side) => {
    this.setState({ side, doc: false, form: { login: '', pass: '' } });
  };

  onSend = async () => {
    const { login, pass } = this.state.form;
    if (login === '' || pass === '') {
      message.warning('Por favor, preencha todos os campos');
    } else {
      this.setState({ load: true });
      const values = {
        LOGIN: login,
        PASSWORD: pass,
        VISIBLE: this.state.side === 0 ? "'D','P','A'" : "'SC'",
      };

      await POST_API('/credential/login.php', {
        token: 'X',
        master: JSON.stringify(values),
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            message.success(res.msg);
            setToken(res.token);
            setType(res.type);
            this.setState({ _navigate: true });
          } else {
            message.warning(res.msg);
          }
        })
        .catch(() => {
          POST_CATCH();
        })
        .finally(() => {
          this.setState({ load: false });
        });
    }
  };

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: ignora
  render = () => {
    if (this.state._navigate) {
      return <Navigate to="/painel" />;
    }

    return (
      <Layout.Content className="web-body">
        <Layout.Content className="auth-content">
          <Row className="auth-box-login">
            <Col
              className={this.state.side === 0 ? 'auth-col active' : 'auth-col'}
            >
              <Link to="/">
                <Button
                  className="btn-primary btn-auth"
                  shape="circle"
                  type="primary"
                >
                  <IoArrowUndo size={22} />
                </Button>
              </Link>
              {this.state.side !== 0 ? (
                <Row gutter={[8, 8]} justify={'center'}>
                  <Col
                    span={24}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Typography className="auth-col-title">
                      Sou Advogado
                    </Typography>
                    <Typography
                      className="auth-col-text"
                      style={{ marginTop: 10 }}
                    >
                      Lorem ipsum dolor sit.
                    </Typography>
                    <Typography
                      className="auth-col-text"
                      style={{ marginTop: 10 }}
                    >
                      Lorem ipsum dolor sit amet elit.
                    </Typography>
                    <Button
                      className="btn-primary"
                      onClick={() => this.onChangeSide(0)}
                      shape="round"
                      style={{ marginTop: 20 }}
                      type="primary"
                    >
                      CONTINUAR
                    </Button>
                  </Col>
                </Row>
              ) : (
                <>
                  <Typography className="auth-col-title">
                    Sou Advogado
                  </Typography>
                  <Row gutter={[8, 8]} style={{ marginTop: 10 }}>
                    <Col>
                      <Button className="auth-social">
                        <FaFacebookF />
                      </Button>
                    </Col>
                    <Col>
                      <Button className="auth-social">
                        <FaGoogle />
                      </Button>
                    </Col>
                    <Col>
                      <Button className="auth-social">
                        <FaLinkedin />
                      </Button>
                    </Col>
                  </Row>
                  <Typography
                    className="auth-col-text color-white"
                    style={{ marginTop: 10 }}
                  >
                    Ou utilize o seu CPF para o acesso:
                  </Typography>
                  <ReactInputMask
                    mask={
                      this.state.doc ? '99.999.999/9999-99' : '999.999.999-99'
                    }
                    maskChar={''}
                    maxLength={this.state.doc ? 18 : 14}
                    onChange={(v) =>
                      this.onChangeValue('login', v.target.value)
                    }
                    value={this.state.form.login}
                  >
                    {(props) => (
                      <Input
                        {...props}
                        className="auth-input"
                        placeholder={this.state.doc ? 'CNPJ' : 'CPF'}
                        prefix={<IoPerson />}
                        size="large"
                        suffix={
                          <Switch
                            checkedChildren="CNPJ"
                            onChange={(v) => this.setState({ doc: v })}
                            unCheckedChildren="CPF"
                            value={this.state.doc}
                          />
                        }
                        type={'text'}
                      />
                    )}
                  </ReactInputMask>
                  <Input
                    className="auth-input"
                    defaultValue={this.state.form.pass}
                    onChange={(v) => this.onChangeValue('pass', v.target.value)}
                    placeholder="Senha"
                    prefix={<IoLockOpen />}
                    size="large"
                    suffix={
                      this.state.view ? (
                        <IoEyeOff
                          onClick={() => this.setState({ view: false })}
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <IoEye
                          onClick={() => this.setState({ view: true })}
                          style={{ cursor: 'pointer' }}
                        />
                      )
                    }
                    type={this.state.view ? 'text' : 'password'}
                  />
                  <Link to="/esqueceuasenha">
                    <Typography
                      className="auth-col-text color-white"
                      style={{ marginTop: 10 }}
                    >
                      Esqueceu a Senha?
                    </Typography>
                  </Link>
                  <div className="plan-card-button">
                    <Button
                      className="btn-outline"
                      loading={this.state.load}
                      onClick={this.onSend}
                      shape="round"
                      type="default"
                    >
                      ENTRAR
                    </Button>
                  </div>
                </>
              )}
            </Col>
            <Col
              className={
                this.state.side === 1 || this.state.side === 2
                  ? 'auth-col active'
                  : 'auth-col'
              }
            >
              {this.state.side === 0 ? (
                <Row gutter={[8, 8]} justify={'center'}>
                  <Col
                    span={24}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Typography className="auth-col-title">
                      Sou Cliente
                    </Typography>
                    <Typography
                      className="auth-col-text"
                      style={{ marginTop: 10 }}
                    >
                      Lorem ipsum dolor sit.
                    </Typography>
                    <Typography
                      className="auth-col-text"
                      style={{ marginTop: 10 }}
                    >
                      Lorem ipsum dolor sit amet elit.
                    </Typography>
                    <Button
                      className="btn-primary"
                      onClick={() => this.onChangeSide(1)}
                      shape="round"
                      style={{ marginTop: 20 }}
                      type="primary"
                    >
                      CONTINUAR
                    </Button>
                  </Col>
                </Row>
              ) : (
                <>
                  <Typography className="auth-col-title">
                    Sou Cliente
                  </Typography>
                  <Row gutter={[8, 8]} style={{ marginTop: 10 }}>
                    <Col>
                      <Button className="auth-social">
                        <FaFacebookF />
                      </Button>
                    </Col>
                    <Col>
                      <Button className="auth-social">
                        <FaGoogle />
                      </Button>
                    </Col>
                    <Col>
                      <Button className="auth-social">
                        <FaLinkedin />
                      </Button>
                    </Col>
                  </Row>
                  <Typography
                    className="auth-col-text color-white"
                    style={{ marginTop: 10 }}
                  >
                    Ou utilize o seu CPF para o acesso:
                  </Typography>
                  <ReactInputMask
                    mask={
                      this.state.doc ? '99.999.999/9999-99' : '999.999.999-99'
                    }
                    maskChar={''}
                    maxLength={this.state.doc ? 18 : 14}
                    onChange={(v) =>
                      this.onChangeValue('login', v.target.value)
                    }
                    value={this.state.form.login}
                  >
                    {(props) => (
                      <Input
                        {...props}
                        className="auth-input"
                        placeholder={this.state.doc ? 'CNPJ' : 'CPF'}
                        prefix={<IoPerson />}
                        size="large"
                        suffix={
                          <Switch
                            checkedChildren="CNPJ"
                            onChange={(v) => this.setState({ doc: v })}
                            unCheckedChildren="CPF"
                            value={this.state.doc}
                          />
                        }
                        type={'text'}
                      />
                    )}
                  </ReactInputMask>
                  <Input
                    className="auth-input"
                    defaultValue={this.state.form.pass}
                    onChange={(v) => this.onChangeValue('pass', v.target.value)}
                    placeholder="Senha"
                    prefix={<IoLockOpen />}
                    size="large"
                    suffix={
                      this.state.view ? (
                        <IoEyeOff
                          onClick={() => this.setState({ view: false })}
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <IoEye
                          onClick={() => this.setState({ view: true })}
                          style={{ cursor: 'pointer' }}
                        />
                      )
                    }
                    type={this.state.view ? 'text' : 'password'}
                  />
                  <Link to="/esqueceuasenha">
                    <Typography
                      className="auth-col-text color-white"
                      style={{ marginTop: 10 }}
                    >
                      Esqueceu a Senha?
                    </Typography>
                  </Link>
                  <div className="plan-card-button">
                    <Button
                      className="btn-outline"
                      loading={this.state.load}
                      onClick={this.onSend}
                      shape="round"
                      type="default"
                    >
                      ENTRAR
                    </Button>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Layout.Content>
      </Layout.Content>
    );
  };
}

export default AuthLogin;
